module.exports = __webpack_public_path__ + "img/cloud_left_1.f638f60e.png";